import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import lottieanim from "./lottie.json";
import  LottiePlayer  from 'lottie-react';
import { Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  borderRadius:4,
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function NestedModal({loading,open,setOpen,success}) {
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 400 }}>

          {loading ?  <Box sx={{textAlign:'center'}}>
          <Typography variant="h5" >Adding you now</Typography>
            <LottiePlayer animationData={lottieanim} />
            <Typography>Please wait..</Typography>
          </Box>
 :
          <React.Fragment>
            {success ?
            <Box sx={{textAlign:'center'}}>
             <Typography variant="h5" >
            Thank you. </Typography> <Typography>You will shortly receive a confirmation email. Please click on the button to confirm your subscription to receive alerts for the journals you have chosen.
            </Typography>
            <Button onClick={handleClose}>Close This Message</Button>
            </Box>:
            <Box>
            <p id="child-modal-description">
            Sorry there was an issue. Please try again later.
            </p>
            <Button onClick={handleClose}>Close This Message</Button>
            </Box>
}
          </React.Fragment>
         }
        </Box>
      </Modal>
    </div>
  );
}